export default class UserInfo {
  constructor(props = {}) {
    const fields = ['uuid', 'userId', 'name', 'fullname', 'phone', 'email'];
    fields.forEach(field => {
      this[field] = props[field] || null;
    });

    this.id = this.userId;
  }
}
